<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vETrxb/tc-custom/9781540265050.jpg?1737196545295" alt="This image is the cover for the book Florida Natural Springs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Florida Natural Springs
      </h1>
      <p class="bookDescription body article font2">
        <p>Author Holly Sprinkle unveils the secrets hidden within Florida's aquatic wonders. Florida's springs swirl a spectrum of greens and blues with a crystal clarity seen nowhere else in the world. "Springhunting" is a cherished regional pastime, but these ancient oases have served as a beacon for humans and beasts alike since time immemorial. Giant sloths, mammoths and armadillos once centered their lives around these springs--the endangered West Indian Manatee still seeks refuge in the relatively warm springs during the winter months. These enchanting waters sustain ecosystems and inspire everything from feelings of deep serenity to legends involving curses, ghosts and alien visitation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly Sprinkle
      </h2>
      
      <p class="authorDescription body article">Holly Sprinkle is a writer and instructional designer in Gainesville, Florida. She has a master of arts degree in professional writing from Western Carolina University. After starting as a college professor in writing and literature classrooms, Holly embarked on a career as writer, editor and online course developer. Holly enjoys spending time with her three boys, exploring and photographing Florida's natural wonders. Their favorite spots include Florida's springs, beaches and hiking trails.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c42bf6d